import React, { useState,useEffect } from 'react'

import "./Placement.css";
import { Backtotop,Floatinmenu,Underline,Deptvision,Deptmission } from "../../widgets";
import { placement_menu, placement_officers } from "../../constants/placement";

import {RadialMenu,Profile_display } from "../../components";

import { FaGraduationCap } from "react-icons/fa";



const oracle_placement = "https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/news_img/oracle.webp"
const Placement = () => {

  const desktopImages = [
    "https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/dept_bgs/Placement_bg.webp",
    "https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/dept_bgs/Saaralpicbg.webp"
  ];

  const mobileImages = [
    "https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/dept_bgs/Placement_bgm.webp",
    "https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/dept_bgs/Saaralpicbgm.webp",
  ];

  const [currentIndex, setCurrentIndex] = useState(0);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768); // Detect screen width

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    window.addEventListener("resize", handleResize);

    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prevIndex) => (prevIndex + 1) % desktopImages.length);
    }, 5000); // Change every 5 seconds

    return () => clearInterval(interval);
  }, []);

  const backgroundImage = isMobile ? mobileImages[currentIndex] : desktopImages[currentIndex];


  useEffect(() => {
    document.title='ACCET-Placement';
  }, []);
  return(
    <div className="placement">
      <div className="placementbg" style={{ backgroundImage: `url(${backgroundImage})` }}>
        <div className="placementheading">Placement</div>
      </div>
      <section className='placementdark'>
        <div className='dept_float_menu'>
        <Floatinmenu logo={FaGraduationCap} head="Menu" links={placement_menu} />
        </div>
        <RadialMenu menu_links={placement_menu}/>
        <div className='placement_abt'>
        <Underline heading="Overview"/> 
        <div className='placementtwo-col'>
          <p className='placement_content'>
          Placement Cell is instrumental in facilitating students' transition from academics to successful careers. Through strategic collaboration with industry leaders, these cells secure internships and placements, offering valuable practical exposure. Dedicated teams provide guidance on resume building and interview skills, enhancing overall employability. These efforts across all departments ensure students are well-prepared for fulfilling professional journeys.
          </p>
          <div className="dept_img_holder">
            <img className="dept_img" src={oracle_placement} />
          </div>
        </div>
        <div className='placementtwo-col1'>
          <p className='placement_content'>
          The Placement Cell across various departments plays a pivotal role in shaping the professional trajectories of students. Established to bridge the gap between academics and industry, the Placement Cell actively forges connections with leading companies. By securing internships and placements, the Placement Cell empowers students with practical experience, aligning academic knowledge with real-world challenges. The Placement Cell goes beyond mere placement assistance and serves as a comprehensive career development hub. Through workshops, seminars, and one-on-one counseling, the dedicated team guides students in refining their resumes and honing interview skills. The collaborative efforts of the Placement Cell ensure that graduates are not just academically adept but also possess the practical skills and confidence needed for a successful and fulfilling career in their respective fields.
          </p>
        </div>
        <Underline heading="Officers Incharge"/> 
        <Profile_display list_info={placement_officers} />

        </div>
      </section>

      <Backtotop />
    </div>
  );
};
export default Placement;